import SharedStore from 'shared/stores/shared.store'
import * as api from '../api/seller.api'

class SellerStore extends SharedStore {
  storeName = 'SellerStore'
  childApi = api

  isAppActive = (key) => {
    const { optionKeys } = this.item
    return optionKeys && optionKeys.includes(key)
  }
}

export default new SellerStore()
